// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Utils
import { prop } from '../../../../common/utils/immutableHelper';
import { useTranslator } from '../../../components/i18n/useTranslator';

// Components
import Icon from '../../../components/icons/Icon';
import LinkButton from '../../../components/buttons/LinkButton';

// Actions
import { clearElementAttachmentError } from '../../attachments/attachmentActions';

import './FileUploaderErrorContent.scss';

const mapDispatchToProps = (dispatch) => ({
    dispatchClearError: (id) => dispatch(clearElementAttachmentError({ id })),
});

const FileUploaderErrorContent = ({ error, type, elementId, dispatchClearError }) => {
    const translate = useTranslator('errors');

    const clearError = () => {
        dispatchClearError(elementId);
    };

    // Translate error message if errorLocaleKey is available
    const errorMessage = error?.errorLocaleKey
        ? translate(error.errorLocaleKey, error.context || {})
        : prop('message', error) || `Unable to upload ${type}`;

    const errorExplanation = prop('explanation', error) || 'Sorry, something went wrong';

    return (
        <div className="FileUploaderErrorContent">
            <Icon name="error-alert" />
            <span className="details">
                {errorMessage}
                <br />
                {errorExplanation}
            </span>
            <LinkButton className="cta" onClickFn={clearError}>
                Try another {type}
            </LinkButton>
        </div>
    );
};

FileUploaderErrorContent.propTypes = {
    error: PropTypes.object,
    dispatchClearError: PropTypes.func,
    elementId: PropTypes.string,
    type: PropTypes.string.isRequired,
};

export default connect(null, mapDispatchToProps)(FileUploaderErrorContent);
